import differenceInDays from 'date-fns/differenceInDays';
import format from 'date-fns/format';
import {ChangeEvent, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import style from './BirthdayModalDesc.module.scss';
import Text from '../../common/component/Text';
import useTypedSelector from '../../common/hook/useTypedSelector';
import useUserAgent from '../../common/hook/useUserAgent';
import {actions as commonActions} from '../../common/state/action';
import {
  parseDate,
  getTimeStamp,
  DEFAULT_DATE_FORMAT,
} from '../../common/util/date';
import InputV4 from '../../commonSub/component/InputV4';
import {actions} from '../state/action';

export default function BirthdayModalDesc() {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const userAgent = useUserAgent();
  const [birthday, alert] = useTypedSelector(state => [
    state.auth.birthday || '',
    state.common.pAlerts.find(
      item => item.groupId === BIRTHDAY_P_ALERT_GROUP_ID
    ),
  ]);
  const [formattedBd, setFormattedBd] = useState(getFormattedDate(birthday));

  useEffect(() => {
    if (alert) {
      dispatch(
        commonActions.changePAlertConfirmState({
          groupId: BIRTHDAY_P_ALERT_GROUP_ID,
          disabled:
            !birthday ||
            differenceInDays(Date.now(), getTimeStamp(birthday)) <= 0,
        })
      );
    }
  }, [alert, birthday, dispatch]);

  const onChagneBirthDate = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    dispatch(actions.setValue('birthday', value));
    setFormattedBd(getFormattedDate(value));
  };

  const showCalendar = (e: EventObject) => {
    const inputTarget = e.currentTarget as any;
    const isFirefox = userAgent?.isFirefox;
    if (
      isFirefox &&
      'showPicker' in inputTarget &&
      typeof inputTarget.showPicker === 'function'
    ) {
      e.preventDefault();
      inputTarget.showPicker();
    }
  };

  return (
    <div>
      <Text className="s12-regular-grey08">
        {t('authentication_global_popup_content')}
      </Text>
      <div className="relative mt-10">
        <InputV4
          type="text"
          placeholder={DATE_BIRTHDAY_UPPER_FORMAT}
          inputClassName={cn(
            'h-52 w-full disabled:!opacity-100 disabled:!text-white-black disabled:!placeholder-grey-06 !border-0'
            // TODO: 조건 및 API 결과에 따라 수정 필요
            // !formattedBd && 'disabled:!placeholder-red',
          )}
          className="bg-background-02 rounded-8"
          value={formattedBd}
          disabled
        />
        <input
          onChange={onChagneBirthDate}
          onClick={showCalendar}
          type="date"
          className={cn(style.date, 'opacity-0 absolute inset-0 min-w-full')}
          max={format(Date.now(), 'yyyy-MM-dd')}
          value={birthday}
        />
      </div>
    </div>
  );
}

export const BIRTHDAY_P_ALERT_GROUP_ID = 'use-ticket-birthday';
const DATE_BIRTHDAY_FORMAT = DEFAULT_DATE_FORMAT.replace(/\./g, '/');
const DATE_BIRTHDAY_UPPER_FORMAT = DATE_BIRTHDAY_FORMAT.toUpperCase();

export function getFormattedDate(value: string) {
  if (!value) return '';
  const d = parseDate(value);
  return format(d, DATE_BIRTHDAY_FORMAT);
}
